module.exports = __webpack_public_path__ + "static/img/10.5891396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/10.png
// module id = yK2o
// module chunks = 0